import script from "./PairDevices.vue?vue&type=script&setup=true&lang=ts"
export * from "./PairDevices.vue?vue&type=script&setup=true&lang=ts"

import "./PairDevices.vue?vue&type=style&index=0&id=2e97ef96&lang=scss"

const __exports__ = script;

export default __exports__